import React from 'react';

interface SortableHeaderProps {
  label: string;
  field: string;
  currentSort: string;
  currentOrder: 'asc' | 'desc';
  onSort: (field: string) => void;
  className?: string;
  align?: 'left' | 'center' | 'right';
}

export const SortableHeader: React.FC<SortableHeaderProps> = ({
  label,
  field,
  currentSort,
  currentOrder,
  onSort,
  className = '',
  align = 'left',
}) => {
  const isActive = currentSort === field;
  const isAsc = isActive && currentOrder === 'asc';
  const isDesc = isActive && currentOrder === 'desc';

  const alignClass =
    align === 'right'
      ? 'justify-end'
      : align === 'center'
      ? 'justify-center'
      : 'justify-start';

  return (
    <th
      className={`cursor-pointer select-none transition-colors hover:bg-gray-50/80 group ${className}`}
      onClick={() => onSort(field)}
      title={`Sort by ${label} (${isActive ? (isAsc ? 'Switch to Descending' : 'Switch to Ascending') : 'Click to sort'})`}
    >
      <div className={`inline-flex items-center gap-1.5 font-semibold text-xs text-gray-700 w-full ${alignClass}`}>
        <span className={isActive ? 'text-brand-700 font-bold' : 'group-hover:text-gray-900'}>
          {label}
        </span>
        <span className={`inline-flex items-center text-xs transition-opacity ${isActive ? 'text-brand-600 opacity-100' : 'text-gray-400 opacity-40 group-hover:opacity-80'}`}>
          {isAsc ? (
            <svg className="w-3.5 h-3.5 text-brand-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M18 15l-6-6-6 6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          ) : isDesc ? (
            <svg className="w-3.5 h-3.5 text-brand-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          ) : (
            <svg className="w-3.5 h-3.5 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M7 15l5 5 5-5M7 9l5-5 5 5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          )}
        </span>
      </div>
    </th>
  );
};
